export const toLocalDatetime = (isoString: string): string => {
	const date = new Date(isoString);
	const offset = date.getTimezoneOffset() * 60000;
	const localDate = new Date(date.getTime() - offset);
	return localDate.toISOString().slice(0, -1);
};

/** Locale-aware date+time for receipts and other user-facing timestamps. */
export function formatLocalizedDateTime(date: Date, language: string): string {
	return new Intl.DateTimeFormat(language, { dateStyle: 'short', timeStyle: 'medium' }).format(date);
}
